import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { INoImages } from './types';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    margin: {
        marginBottom: '0.5em',
    },
    image: {
        marginBottom: '1.5em',
    },
}));

export const NoImages = ({ ...props }: INoImages) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            className={classes.root}
            {...props}
        >
            <img
                src="/static/images/NoData.svg"
                width="50%"
                className={classes.image}
            />
            <Typography variant="h2" className={classes.margin}>
                {t('Placeholder.NoEvidences')}
            </Typography>
            <Typography variant="h5" className={classes.margin}>
                {t('Placeholder.UploadEvidences')}
            </Typography>
        </Box>
    );
};
